import React from 'react'
import PropTypes from 'prop-types'
import { Breadcrumbs as MuiBreadcrumbs } from '@material-ui/core'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { v4 as uuid } from 'uuid'
import { titleCase } from '../Functions/textFormat'
import { Link } from 'react-router-dom'

export const Breadcrumbs = ({
  className,
  links,
  p,
  e,
  s,
  b,
  text,
  ...rest
}) => {
  return (
    <MuiBreadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      className={className}
      style={{
        margin: '18px 8px',
        fontFamily: 'Proxima Nova Regular'
      }}
      {...rest}>
      {links.map((l, i) => {
        return !l ? (
          <p
            key={uuid()}
            style={{
              fontFamily: 'Proxima Nova Regular',
              margin: 0
            }}
            color="textSecondary">
            {e[i]}
          </p>
        ) : !l[i] && (!e[i] || !s[i]) ? (
          <MuiBreadcrumbs
            key={uuid()}
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            className={className}
            style={{
              margin: '18px 8px',
              fontFamily: 'Proxima Nova Regular'
            }}
            {...rest}>
            <Link
              key={uuid()}
              style={{
                textDecoration: 'none'
              }}
              className="text-primary"
              to={b[i]}>
              {text[i]}
            </Link>
          </MuiBreadcrumbs>
        ) : (
          <Link
            key={uuid()}
            style={{
              textDecoration: 'none'
            }}
            className="text-primary"
            to={!l ? '' : l}>
            {/^\d+$/.test(l.split('/').pop()[0])
              ? s[i]
              : titleCase(l.split('/').pop())}
          </Link>
        )
      })}
      {p.map((t) => {
        return (
          <p
            key={uuid()}
            style={{
              fontFamily: 'Proxima Nova Regular',
              margin: 0
            }}
            color="textSecondary">
            {t}
          </p>
        )
      })}
    </MuiBreadcrumbs>
  )
}

Breadcrumbs.propTypes = {
  links: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  p: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  e: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  s: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  b: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  text: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ])
}

Breadcrumbs.displayName = 'bc'

export default Breadcrumbs
